<template>
  <header>
    <div id="contactBtnWrapper">
      <router-link id="contactBtn" class="btn btn--tight btn--white" to="/contact"
        ><div class="iconBtn">
          <svg class="iconBtn__icon">
            <use xlink:href="#envelope"></use>
          </svg>
          <div class="iconBtn__text">Contact</div>
        </div></router-link
      >
    </div>
    <nav id="mainNav">
      <svg id="logoSmall">
        <use xlink:href="#logo"></use>
      </svg>
      <h1 id="chuckTaylorNavTitle">Chuck Taylor</h1>
    </nav>
    <div class="mainHeaderContainer">
      <svg id="logoLarge">
        <use xlink:href="#logo"></use>
      </svg>
      <!-- titles -->
      <div id="mainTitleWrapper">
        <h1 class="mainTitle">Chuck Taylor</h1>
      </div>
      <h2 class="tagline">App Developer</h2>
      <div class="scrollDownIndicator">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </header>
  <!-- SVGs -->
  <svg width="0" height="0" class="hidden">
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.73 83.15" id="logo" aria-hidden="true">
      <path
        d="M79.53,53.08,71.4,38.18a6.57,6.57,0,0,0-.67-1V11.5A11.53,11.53,0,0,0,59.23,0H11.5A11.53,11.53,0,0,0,0,11.5V59.23a11.53,11.53,0,0,0,11.5,11.5H24.81a6.45,6.45,0,0,0,1.48.82h0L50,81a20.7,20.7,0,0,0,9.29,2.16,22.66,22.66,0,0,0,10.88-2.82,21.61,21.61,0,0,0,11.58-18.6A17.83,17.83,0,0,0,79.53,53.08ZM5.5,65.23a8.44,8.44,0,0,1-2.5-6V11.5A8.54,8.54,0,0,1,11.5,3H59.23a8.54,8.54,0,0,1,8.5,8.5V35.23a6.09,6.09,0,0,0-4.77.48A6.16,6.16,0,0,0,60.57,38l-.16-.3h0A6.22,6.22,0,0,0,52,35.26a4.27,4.27,0,0,0-1.28,1.1,5.92,5.92,0,0,0-1,2.14l0,.21a6.21,6.21,0,0,0-6.83-.58,6.13,6.13,0,0,0-2.38,2.33L34.82,30.23A6.26,6.26,0,0,0,29.34,27a6.1,6.1,0,0,0-3,.76h0a6.24,6.24,0,0,0-2.48,8.43h0L38.48,62.88l-7.81-3h0a6.05,6.05,0,0,0-2.16-.39,6.22,6.22,0,0,0-5.84,4v0a6,6,0,0,0-.39,2.15,6.13,6.13,0,0,0,.34,2H11.5A8.44,8.44,0,0,1,5.5,65.23ZM68.71,77.7a19.67,19.67,0,0,1-9.44,2.45,17.64,17.64,0,0,1-8-1.88l-.13-.06L27.4,68.76h0a3.24,3.24,0,0,1-2.09-3,3.29,3.29,0,0,1,.2-1.11h0a3.23,3.23,0,0,1,3-2.08,3.1,3.1,0,0,1,1.11.2l11.59,4.38a1.48,1.48,0,0,0,1.66-.41A1.5,1.5,0,0,0,43.06,65L26.54,34.75a3.07,3.07,0,0,1-.39-1.52,3.23,3.23,0,0,1,1.67-2.84h0A3.1,3.1,0,0,1,29.34,30a3.23,3.23,0,0,1,2.84,1.67l8.14,14.9v0l5,9.08a1.5,1.5,0,1,0,2.64-1.44l-5-9.12a3.31,3.31,0,0,1-.38-1.51,3.23,3.23,0,0,1,1.67-2.83,3.15,3.15,0,0,1,1.53-.4A3.25,3.25,0,0,1,48.59,42l5,9.12a1.5,1.5,0,0,0,2.63-1.44l-3.15-5.77h0s0,0,0,0h0a7,7,0,0,1-.68-3.06,5.62,5.62,0,0,1,.33-2,2.62,2.62,0,0,1,.35-.63,1.2,1.2,0,0,1,.37-.32,3.14,3.14,0,0,1,1.53-.39,3.19,3.19,0,0,1,2.83,1.67h0l2.72,5v0l2.25,4.12a1.5,1.5,0,1,0,2.63-1.44L63.12,42.7a3.22,3.22,0,0,1,1.28-4.36A3.25,3.25,0,0,1,65.93,38a3.22,3.22,0,0,1,2.83,1.67l8.14,14.9a15,15,0,0,1,1.83,7.21C78.74,67.89,75.09,74.22,68.71,77.7Z"
      />
    </symbol>
    <symbol aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" id="envelope">
      <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
      ></path>
    </symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" id="githubIcon" aria-hidden="true">
      <path
        fill="currentColor"
        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
      ></path>
    </symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" id="websiteIcon" aria-hidden="true">
      <path
        fill="currentColor"
        d="M25 2C14.393 2 5.445 9.219 2.799 19h2.086a20.972 20.972 0 0 1 3.521-6.818c1.708.962 3.684 1.767 5.87 2.386A37.824 37.824 0 0 0 13.397 19h2.04c.202-1.376.48-2.69.808-3.938 2.41.532 5.017.846 7.754.909V19h2v-3.03c2.737-.062 5.344-.374 7.754-.906a36.14 36.14 0 0 1 .81 3.936h2.039a37.824 37.824 0 0 0-.877-4.432c2.185-.62 4.16-1.423 5.869-2.386A20.972 20.972 0 0 1 45.115 19h2.086C44.555 9.219 35.607 2 25 2zm-1 2.121v9.85a38.452 38.452 0 0 1-7.186-.838C18.455 8.213 21.062 4.768 24 4.12zm2 0c2.938.647 5.545 4.092 7.186 9.012A38.446 38.446 0 0 1 26 13.97V4.12zm-6.867.733c-1.76 1.855-3.235 4.537-4.297 7.787-1.912-.54-3.635-1.221-5.113-2.014a20.997 20.997 0 0 1 9.41-5.773zm11.734 0a20.997 20.997 0 0 1 9.41 5.773c-1.478.793-3.2 1.473-5.113 2.014-1.062-3.25-2.536-5.932-4.297-7.787zM3 21l2.54 8h2.33l2.112-5.98 2.12 5.98h2.279l2.584-8H14.8l-1.633 5.588L11.303 21H8.748l-1.945 5.494L5.199 21H3zm15.018 0l2.54 8h2.33L25 23.02 27.12 29h2.278l2.584-8h-2.164l-1.632 5.588L26.32 21h-2.554l-1.946 5.494L20.217 21h-2.2zm14.964 0l2.551 8h2.338l2.121-5.98L42.12 29h2.287L47 21h-2.172l-1.639 5.588L41.32 21h-2.565L36.8 26.494 35.189 21h-2.207zM2.8 31C5.445 40.781 14.393 48 25 48s19.555-7.219 22.201-17h-2.086a20.972 20.972 0 0 1-3.521 6.818c-1.708-.962-3.684-1.767-5.87-2.386.365-1.4.666-2.877.878-4.432h-2.04a36.164 36.164 0 0 1-.808 3.938A40.373 40.373 0 0 0 26 34.029V31h-2v3.03c-2.737.062-5.344.374-7.754.906A36.14 36.14 0 0 1 15.438 31h-2.04c.212 1.555.513 3.031.877 4.432-2.185.62-4.16 1.423-5.869 2.386A20.972 20.972 0 0 1 4.885 31H2.799zM24 36.03v9.849c-2.938-.647-5.545-4.092-7.186-9.012A38.446 38.446 0 0 1 24 36.03zm2 0c2.542.062 4.96.354 7.186.837-1.642 4.92-4.248 8.365-7.186 9.012v-9.85zm-11.162 1.33c1.063 3.25 2.535 5.93 4.295 7.786a20.997 20.997 0 0 1-9.41-5.773c1.478-.793 3.202-1.473 5.115-2.014zm20.326 0c1.912.54 3.635 1.22 5.113 2.013a20.997 20.997 0 0 1-9.41 5.773c1.76-1.855 3.234-4.537 4.297-7.787z"
      ></path>
    </symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" id="appleIcon" aria-hidden="true">
      <path
        fill="currentColor"
        d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
      ></path>
    </symbol>
    <symbol
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 553.048 553.048"
      id="androidIcon"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M76.774 179.141c-9.529 0-17.614 3.323-24.26 9.969-6.646 6.646-9.97 14.621-9.97 23.929v142.914c0 9.541 3.323 17.619 9.97 24.266 6.646 6.646 14.731 9.97 24.26 9.97 9.522 0 17.558-3.323 24.101-9.97 6.53-6.646 9.804-14.725 9.804-24.266V213.039c0-9.309-3.323-17.283-9.97-23.929-6.647-6.646-14.627-9.969-23.935-9.969zM351.972 50.847L375.57 7.315c1.549-2.882.998-5.092-1.658-6.646-2.883-1.34-5.098-.661-6.646 1.989l-23.928 43.88c-21.055-9.309-43.324-13.972-66.807-13.972-23.488 0-45.759 4.664-66.806 13.972l-23.929-43.88c-1.555-2.65-3.77-3.323-6.646-1.989-2.662 1.561-3.213 3.764-1.658 6.646l23.599 43.532c-23.929 12.203-42.987 29.198-57.167 51.022-14.18 21.836-21.273 45.698-21.273 71.628h307.426c0-25.924-7.094-49.787-21.273-71.628-14.181-21.824-33.129-38.819-56.832-51.022zm-136.433 63.318c-2.552 2.558-5.6 3.831-9.143 3.831-3.55 0-6.536-1.273-8.972-3.831-2.436-2.546-3.654-5.582-3.654-9.137 0-3.543 1.218-6.585 3.654-9.137 2.436-2.546 5.429-3.819 8.972-3.819s6.591 1.273 9.143 3.819c2.546 2.558 3.825 5.594 3.825 9.137-.007 3.549-1.285 6.591-3.825 9.137zm140.086 0c-2.441 2.558-5.434 3.831-8.971 3.831-3.551 0-6.598-1.273-9.145-3.831-2.551-2.546-3.824-5.582-3.824-9.137 0-3.543 1.273-6.585 3.824-9.137 2.547-2.546 5.594-3.819 9.145-3.819 3.543 0 6.529 1.273 8.971 3.819 2.438 2.558 3.654 5.594 3.654 9.137 0 3.549-1.217 6.591-3.654 9.137zM123.971 406.804c0 10.202 3.543 18.838 10.63 25.925 7.093 7.087 15.729 10.63 25.924 10.63h24.596l.337 75.454c0 9.528 3.323 17.619 9.969 24.266s14.627 9.97 23.929 9.97c9.523 0 17.613-3.323 24.26-9.97s9.97-14.737 9.97-24.266v-75.447h45.864v75.447c0 9.528 3.322 17.619 9.969 24.266s14.73 9.97 24.26 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.737 9.969-24.266v-75.447h24.928c9.969 0 18.494-3.544 25.594-10.631 7.086-7.087 10.631-15.723 10.631-25.924V185.45h-305.09v221.354zm352.304-227.663c-9.309 0-17.283 3.274-23.93 9.804-6.646 6.542-9.969 14.578-9.969 24.094v142.914c0 9.541 3.322 17.619 9.969 24.266s14.627 9.97 23.93 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.725 9.969-24.266V213.039c0-9.517-3.322-17.552-9.969-24.094-6.647-6.53-14.737-9.804-24.26-9.804z"
      ></path>
    </symbol>
    <symbol aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" id="link-solid">
      <path
        fill="currentColor"
        d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
      ></path>
    </symbol>
    <symbol aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 135 40" id="appStoreBadge">
      <g>
        <path
          d="M130.2,40H4.73A4.74,4.74,0,0,1,0,35.27V4.73A4.73,4.73,0,0,1,4.73,0H130.2A4.8,4.8,0,0,1,135,4.73V35.27A4.81,4.81,0,0,1,130.2,40Z"
          fill="#a6a6a6"
        />
        <path
          d="M134,35.27a3.83,3.83,0,0,1-3.83,3.83H4.73A3.84,3.84,0,0,1,.89,35.27V4.72A3.84,3.84,0,0,1,4.73.89H130.2A3.83,3.83,0,0,1,134,4.72V35.27Z"
        />
        <g>
          <path
            d="M30.13,19.78a5.79,5.79,0,0,1,2.76-4.86,6,6,0,0,0-4.68-2.53c-2-.2-3.87,1.18-4.87,1.18s-2.57-1.16-4.23-1.12a6.22,6.22,0,0,0-5.24,3.19c-2.27,3.93-.58,9.69,1.59,12.86,1.09,1.55,2.36,3.29,4,3.23s2.23-1,4.19-1,2.51,1,4.21,1,2.84-1.56,3.89-3.13a13,13,0,0,0,1.78-3.62A5.61,5.61,0,0,1,30.13,19.78Z"
            fill="#fff"
          />
          <path
            d="M26.93,10.31a5.71,5.71,0,0,0,1.3-4.09,5.77,5.77,0,0,0-3.75,1.94,5.4,5.4,0,0,0-1.34,3.94A4.83,4.83,0,0,0,26.93,10.31Z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            d="M53.65,31.5H51.37l-1.24-3.91H45.81L44.62,31.5H42.41l4.28-13.3h2.65ZM49.76,26l-1.13-3.47c-.12-.36-.34-1.19-.67-2.51h0c-.13.57-.34,1.41-.63,2.51L46.18,26Z"
            fill="#fff"
          />
          <path
            d="M64.66,26.59a5.47,5.47,0,0,1-1.32,3.87,3.87,3.87,0,0,1-2.94,1.26,3,3,0,0,1-2.73-1.36h0v5H55.5V25.07c0-1,0-2.08-.08-3.16H57.3l.12,1.52h0a3.54,3.54,0,0,1,3.23-1.72,3.58,3.58,0,0,1,2.84,1.34A5.35,5.35,0,0,1,64.66,26.59Zm-2.17.08a3.94,3.94,0,0,0-.63-2.31A2.17,2.17,0,0,0,60,23.41a2.21,2.21,0,0,0-1.43.52,2.42,2.42,0,0,0-.84,1.37,3.23,3.23,0,0,0-.1.65v1.6a2.56,2.56,0,0,0,.65,1.77,2.11,2.11,0,0,0,1.66.72,2.2,2.2,0,0,0,1.88-.92A4.08,4.08,0,0,0,62.49,26.67Z"
            fill="#fff"
          />
          <path
            d="M75.7,26.59a5.47,5.47,0,0,1-1.32,3.87,3.88,3.88,0,0,1-2.95,1.26,2.93,2.93,0,0,1-2.72-1.36h0v5H66.54V25.07c0-1,0-2.08-.08-3.16h1.87l.12,1.52h0a3.79,3.79,0,0,1,6.07-.38A5.3,5.3,0,0,1,75.7,26.59Zm-2.17.08a3.87,3.87,0,0,0-.64-2.31A2.15,2.15,0,0,0,71,23.41a2.17,2.17,0,0,0-1.43.52,2.42,2.42,0,0,0-.84,1.37,2.64,2.64,0,0,0-.1.65v1.6a2.55,2.55,0,0,0,.64,1.77A2.13,2.13,0,0,0,71,30a2.18,2.18,0,0,0,1.87-.92A4.09,4.09,0,0,0,73.53,26.67Z"
            fill="#fff"
          />
          <path
            d="M88,27.77a3.57,3.57,0,0,1-1.18,2.77,5.29,5.29,0,0,1-3.63,1.16,6.29,6.29,0,0,1-3.45-.83l.5-1.78a5.78,5.78,0,0,0,3.08.85,2.94,2.94,0,0,0,1.88-.54A1.79,1.79,0,0,0,85.91,28a1.87,1.87,0,0,0-.56-1.37,5.13,5.13,0,0,0-1.83-1Q80,24.24,80,21.74a3.37,3.37,0,0,1,1.23-2.69A4.82,4.82,0,0,1,84.51,18a6.49,6.49,0,0,1,3,.63L87,20.37a5.19,5.19,0,0,0-2.54-.61,2.58,2.58,0,0,0-1.76.55,1.6,1.6,0,0,0-.53,1.21,1.62,1.62,0,0,0,.61,1.3,6.78,6.78,0,0,0,1.93,1,6.5,6.5,0,0,1,2.53,1.62A3.35,3.35,0,0,1,88,27.77Z"
            fill="#fff"
          />
          <path
            d="M95.09,23.51H92.74v4.66c0,1.18.41,1.77,1.24,1.77a3.64,3.64,0,0,0,1-.1L95,31.46a4.78,4.78,0,0,1-1.66.24,2.55,2.55,0,0,1-2-.77,3.75,3.75,0,0,1-.72-2.59V23.51h-1.4v-1.6h1.4V20.15l2.1-.63v2.39h2.35Z"
            fill="#fff"
          />
          <path
            d="M105.69,26.63a5.28,5.28,0,0,1-1.26,3.63,4.52,4.52,0,0,1-3.52,1.46,4.28,4.28,0,0,1-3.36-1.4,5.07,5.07,0,0,1-1.26-3.53,5.21,5.21,0,0,1,1.3-3.66,4.49,4.49,0,0,1,3.48-1.42,4.41,4.41,0,0,1,3.4,1.4A5.09,5.09,0,0,1,105.69,26.63Zm-2.21.07a4.33,4.33,0,0,0-.57-2.28,2.2,2.2,0,0,0-3.87,0,4.32,4.32,0,0,0-.57,2.32A4.23,4.23,0,0,0,99,29a2.18,2.18,0,0,0,3.85,0A4.33,4.33,0,0,0,103.48,26.7Z"
            fill="#fff"
          />
          <path
            d="M112.62,23.78a3.55,3.55,0,0,0-.67-.06,2,2,0,0,0-1.74.85,3.25,3.25,0,0,0-.53,1.9v5h-2.13l0-6.57c0-1.11,0-2.11-.08-3h1.85l.08,1.84h.06a3.25,3.25,0,0,1,1.07-1.52,2.53,2.53,0,0,1,1.54-.52,4.09,4.09,0,0,1,.53,0Z"
            fill="#fff"
          />
          <path
            d="M122.16,26.25a5.26,5.26,0,0,1-.08,1h-6.4a2.81,2.81,0,0,0,.93,2.17,3.16,3.16,0,0,0,2.09.67,7.15,7.15,0,0,0,2.59-.45l.33,1.48a7.9,7.9,0,0,1-3.21.59,4.68,4.68,0,0,1-3.51-1.31,4.84,4.84,0,0,1-1.27-3.52,5.51,5.51,0,0,1,1.18-3.62,4.11,4.11,0,0,1,3.36-1.54,3.59,3.59,0,0,1,3.14,1.54A5.24,5.24,0,0,1,122.16,26.25Zm-2-.55a2.85,2.85,0,0,0-.41-1.64,1.88,1.88,0,0,0-1.7-.89,2,2,0,0,0-1.7.87,3.25,3.25,0,0,0-.63,1.66Z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            d="M49.05,10A3.28,3.28,0,0,1,48,12.67a4.19,4.19,0,0,1-2.78.82,11.22,11.22,0,0,1-1.53-.08V7a11.2,11.2,0,0,1,1.8-.13,3.87,3.87,0,0,1,2.59.74A3,3,0,0,1,49.05,10Zm-1.11,0a2.41,2.41,0,0,0-.6-1.76,2.36,2.36,0,0,0-1.77-.61,4.22,4.22,0,0,0-.85.07v4.89a5.56,5.56,0,0,0,.71,0A2.52,2.52,0,0,0,47.29,12,2.72,2.72,0,0,0,47.94,10Z"
            fill="#fff"
          />
          <path
            d="M54.91,11a2.59,2.59,0,0,1-.62,1.78,2.23,2.23,0,0,1-1.73.72,2.1,2.1,0,0,1-1.65-.69,2.52,2.52,0,0,1-.62-1.74,2.55,2.55,0,0,1,.64-1.79,2.21,2.21,0,0,1,1.71-.7,2.16,2.16,0,0,1,1.67.69A2.5,2.5,0,0,1,54.91,11Zm-1.09,0A2.12,2.12,0,0,0,53.54,10a1,1,0,0,0-.94-.56,1.06,1.06,0,0,0-1,.56,2.14,2.14,0,0,0-.28,1.14,2.09,2.09,0,0,0,.28,1.12,1.07,1.07,0,0,0,1.89,0A2.16,2.16,0,0,0,53.82,11.07Z"
            fill="#fff"
          />
          <path
            d="M62.76,8.72l-1.47,4.71h-1l-.61-2a14.24,14.24,0,0,1-.38-1.53h0a11.4,11.4,0,0,1-.38,1.53l-.65,2h-1L55.93,8.72H57L57.54,11c.13.53.24,1,.32,1.51h0q.12-.59.39-1.5l.67-2.25h.86l.64,2.2c.15.54.28,1.06.37,1.55h0a15.33,15.33,0,0,1,.32-1.55l.58-2.2Z"
            fill="#fff"
          />
          <path
            d="M68.2,13.43h-1v-2.7c0-.83-.32-1.25-1-1.25a1,1,0,0,0-.76.35,1.24,1.24,0,0,0-.29.81v2.79H64.1V10.07q0-.63,0-1.35H65l.05.73h0a1.54,1.54,0,0,1,.54-.57,1.81,1.81,0,0,1,1-.26,1.47,1.47,0,0,1,1.09.43,2,2,0,0,1,.55,1.56Z"
            fill="#fff"
          />
          <path d="M71.09,13.43H70V6.56h1Z" fill="#fff" />
          <path
            d="M77.26,11a2.59,2.59,0,0,1-.62,1.78,2.23,2.23,0,0,1-1.73.72,2.1,2.1,0,0,1-1.65-.69,2.52,2.52,0,0,1-.62-1.74,2.55,2.55,0,0,1,.64-1.79A2.21,2.21,0,0,1,75,8.62a2.16,2.16,0,0,1,1.67.69A2.5,2.5,0,0,1,77.26,11Zm-1.09,0A2.12,2.12,0,0,0,75.89,10,1,1,0,0,0,75,9.39,1.06,1.06,0,0,0,74,10a2.14,2.14,0,0,0-.28,1.14A2.09,2.09,0,0,0,74,12.21a1.07,1.07,0,0,0,1.89,0A2.16,2.16,0,0,0,76.17,11.07Z"
            fill="#fff"
          />
          <path
            d="M82.33,13.43h-.94l-.08-.54h0a1.62,1.62,0,0,1-1.38.65,1.39,1.39,0,0,1-1.07-.43,1.33,1.33,0,0,1-.37-1,1.48,1.48,0,0,1,.72-1.32,3.79,3.79,0,0,1,2-.44V10.3c0-.62-.33-.93-1-.93A2.19,2.19,0,0,0,79,9.72L78.8,9a3,3,0,0,1,1.61-.41c1.23,0,1.85.65,1.85,2v1.74A8,8,0,0,0,82.33,13.43Zm-1.09-1.62v-.72c-1.15,0-1.73.29-1.73.95a.69.69,0,0,0,.2.55.74.74,0,0,0,.51.18,1,1,0,0,0,.64-.22.84.84,0,0,0,.36-.55A.55.55,0,0,0,81.24,11.81Z"
            fill="#fff"
          />
          <path
            d="M88.29,13.43h-.93l0-.75h0a1.59,1.59,0,0,1-1.52.86,1.74,1.74,0,0,1-1.41-.67,2.55,2.55,0,0,1-.56-1.73,2.73,2.73,0,0,1,.61-1.86,1.87,1.87,0,0,1,1.45-.66,1.43,1.43,0,0,1,1.33.64h0V6.56h1v5.6C88.25,12.62,88.26,13.05,88.29,13.43Zm-1.09-2v-.78a1.42,1.42,0,0,0,0-.33,1.24,1.24,0,0,0-.38-.64,1,1,0,0,0-.7-.25,1.06,1.06,0,0,0-.92.46,2,2,0,0,0-.34,1.2,1.89,1.89,0,0,0,.32,1.13,1.1,1.1,0,0,0,.92.47,1,1,0,0,0,.83-.39A1.31,1.31,0,0,0,87.2,11.44Z"
            fill="#fff"
          />
          <path
            d="M97.25,11a2.59,2.59,0,0,1-.62,1.78,2.23,2.23,0,0,1-1.73.72,2.1,2.1,0,0,1-1.65-.69,2.52,2.52,0,0,1-.62-1.74,2.55,2.55,0,0,1,.64-1.79A2.21,2.21,0,0,1,95,8.62a2.16,2.16,0,0,1,1.67.69A2.5,2.5,0,0,1,97.25,11Zm-1.09,0A2.12,2.12,0,0,0,95.88,10a1,1,0,0,0-.94-.56A1.06,1.06,0,0,0,94,10a2.14,2.14,0,0,0-.28,1.14A2.09,2.09,0,0,0,94,12.21a1.07,1.07,0,0,0,1.89,0A2.16,2.16,0,0,0,96.16,11.07Z"
            fill="#fff"
          />
          <path
            d="M102.88,13.43h-1v-2.7c0-.83-.32-1.25-1-1.25a.94.94,0,0,0-.76.35,1.24,1.24,0,0,0-.29.81v2.79h-1V10.07c0-.42,0-.87,0-1.35h.92l0,.73h0a1.63,1.63,0,0,1,.54-.57,1.86,1.86,0,0,1,.95-.26,1.49,1.49,0,0,1,1.1.43,2.08,2.08,0,0,1,.54,1.56Z"
            fill="#fff"
          />
          <path
            d="M109.94,9.5h-1.16v2.29c0,.59.21.88.61.88a2,2,0,0,0,.47-.05l0,.79a2.33,2.33,0,0,1-.82.12,1.28,1.28,0,0,1-1-.38,1.85,1.85,0,0,1-.35-1.27V9.5h-.69V8.72h.69V7.86l1-.31V8.72h1.15V9.5Z"
            fill="#fff"
          />
          <path
            d="M115.48,13.43h-1V10.75c0-.84-.31-1.27-.94-1.27a1,1,0,0,0-1,.74,1.35,1.35,0,0,0,0,.38v2.83h-1V6.56h1V9.4h0a1.58,1.58,0,0,1,1.41-.78,1.43,1.43,0,0,1,1.08.43,2.11,2.11,0,0,1,.53,1.58Z"
            fill="#fff"
          />
          <path
            d="M121.21,10.85a3.08,3.08,0,0,1,0,.48H118a1.38,1.38,0,0,0,.45,1.07,1.57,1.57,0,0,0,1,.33,3.46,3.46,0,0,0,1.27-.23l.16.73a4,4,0,0,1-1.58.29,2.29,2.29,0,0,1-1.72-.64,2.37,2.37,0,0,1-.62-1.73,2.68,2.68,0,0,1,.58-1.78,2,2,0,0,1,1.65-.76,1.78,1.78,0,0,1,1.54.76A2.53,2.53,0,0,1,121.21,10.85Zm-1-.27a1.32,1.32,0,0,0-.21-.8.92.92,0,0,0-.83-.44,1,1,0,0,0-.83.43,1.46,1.46,0,0,0-.31.81Z"
            fill="#fff"
          />
        </g>
      </g>
    </symbol>
    <symbol
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 338.89 100"
      id="googlePlayBadge"
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="-1037.05"
          y1="-1765.69"
          x2="-1040.66"
          y2="-1763.83"
          gradientTransform="translate(12125.8 39838.07) scale(11.64 22.55)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#00a0ff" />
          <stop offset="0.01" stop-color="#00a1ff" />
          <stop offset="0.26" stop-color="#00beff" />
          <stop offset="0.51" stop-color="#00d2ff" />
          <stop offset="0.76" stop-color="#00dfff" />
          <stop offset="1" stop-color="#00e3ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="-1007.28"
          y1="-1702.6"
          x2="-1013.89"
          y2="-1702.6"
          gradientTransform="translate(9296.13 13160.05) scale(9.15 7.7)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#ffe000" />
          <stop offset="0.41" stop-color="#ffbd00" />
          <stop offset="0.78" stop-color="orange" />
          <stop offset="1" stop-color="#ff9c00" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="-1059.47"
          y1="-1734.06"
          x2="-1063.26"
          y2="-1729.15"
          gradientTransform="translate(15975.35 20131.83) scale(15.02 11.58)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#ff3a44" />
          <stop offset="1" stop-color="#c31162" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1="-1062.39"
          y1="-1737.8"
          x2="-1060.7"
          y2="-1735.61"
          gradientTransform="translate(15975.35 20109.45) scale(15.02 11.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#32a071" />
          <stop offset="0.07" stop-color="#2da771" />
          <stop offset="0.48" stop-color="#15cf74" />
          <stop offset="0.8" stop-color="#06e775" />
          <stop offset="1" stop-color="#00f076" />
        </linearGradient>
      </defs>
      <path
        d="M326.33,100H12.56A12.57,12.57,0,0,1,0,87.5v-75A12.55,12.55,0,0,1,12.56,0H326.33a12.55,12.55,0,0,1,12.56,12.5v75A12.57,12.57,0,0,1,326.33,100Z"
      />
      <path
        d="M326.33,2a10.56,10.56,0,0,1,10.56,10.5v75A10.54,10.54,0,0,1,326.33,98H12.56A10.56,10.56,0,0,1,2,87.5v-75A10.54,10.54,0,0,1,12.56,2Zm0-2H12.56A12.57,12.57,0,0,0,0,12.5v75A12.55,12.55,0,0,0,12.56,100H326.33a12.55,12.55,0,0,0,12.56-12.5v-75A12.57,12.57,0,0,0,326.33,0Z"
        fill="#a6a6a6"
      />
      <path
        d="M178.53,33.08a7.61,7.61,0,0,1-5.68-2.35,8,8,0,0,1-2.3-5.74,7.85,7.85,0,0,1,2.3-5.73,7.61,7.61,0,0,1,5.67-2.35,7.71,7.71,0,0,1,5.68,2.35,8.29,8.29,0,0,1,0,11.46A7.55,7.55,0,0,1,178.53,33.08Zm-67.34,0a7.88,7.88,0,0,1-5.7-2.32A7.77,7.77,0,0,1,103.14,25a8,8,0,0,1,8-8.08,8,8,0,0,1,3.19.66,6.48,6.48,0,0,1,2.42,1.73l.15.19-1.69,1.65-.17-.2a4.79,4.79,0,0,0-3.92-1.69,5.41,5.41,0,0,0-3.91,1.59A5.6,5.6,0,0,0,105.61,25a5.58,5.58,0,0,0,1.65,4.15,5.73,5.73,0,0,0,7.92,0,4.38,4.38,0,0,0,1.15-2.6h-5.42V24.23h7.74l0,.21a8,8,0,0,1,.12,1.17,7,7,0,0,1-1.94,5.18A7.52,7.52,0,0,1,111.19,33.08Zm89.53-.33h-2.38L191,21.05l.06,2.1v9.59H188.7V17.25h2.72l.08.12,6.87,11-.06-2.1v-9h2.41v15.5Zm-40.13,0h-2.42V19.58H154V17.25h10.81v2.33h-4.2V32.75Zm-8.59,0h-2.41V17.25H152Zm-13.56,0H136V19.58h-4.2V17.25h10.81v2.33h-4.2Zm-8.13,0h-9.26V17.25h9.26v2.33h-6.84v4.25h6.17v2.31h-6.17v4.25h6.84Zm44.31-3.59a5.34,5.34,0,0,0,3.91,1.62,5.22,5.22,0,0,0,3.91-1.62A5.61,5.61,0,0,0,184,25a5.61,5.61,0,0,0-1.59-4.13,5.32,5.32,0,0,0-3.91-1.62,5.18,5.18,0,0,0-3.9,1.62A5.61,5.61,0,0,0,173,25a5.64,5.64,0,0,0,1.58,4.13Z"
        fill="#fff"
      />
      <path
        d="M170.33,54.39A10.64,10.64,0,1,0,181,65,10.47,10.47,0,0,0,170.33,54.39Zm0,17.06a6.47,6.47,0,1,1,6-6.45A6.16,6.16,0,0,1,170.33,71.45ZM147.06,54.39A10.64,10.64,0,1,0,157.72,65,10.47,10.47,0,0,0,147.06,54.39Zm0,17.06a6.47,6.47,0,1,1,6-6.45A6.15,6.15,0,0,1,147.06,71.45Zm-27.7-13.81v4.5h10.81a9.5,9.5,0,0,1-2.45,5.67,11,11,0,0,1-8.33,3.3,12,12,0,0,1,0-24,11.5,11.5,0,0,1,8.13,3.22l3.2-3.19a15.72,15.72,0,0,0-11.31-4.56,16.51,16.51,0,1,0,0,33A15.12,15.12,0,0,0,130.94,71c3-3,3.92-7.17,3.92-10.56a13.73,13.73,0,0,0-.25-2.8H119.36Zm113.28,3.5c-.89-2.39-3.59-6.78-9.11-6.78s-10,4.31-10,10.64a10.4,10.4,0,0,0,10.56,10.64,10.58,10.58,0,0,0,8.86-4.72l-3.61-2.42a6.06,6.06,0,0,1-5.23,2.94,5.41,5.41,0,0,1-5.16-3.22l14.22-5.89Zm-14.5,3.55a5.83,5.83,0,0,1,5.55-6.19,4.1,4.1,0,0,1,3.95,2.25ZM206.58,75h4.67V43.75h-4.67Zm-7.66-18.25h-.17a7.4,7.4,0,0,0-5.61-2.39,10.64,10.64,0,0,0,0,21.26,7.36,7.36,0,0,0,5.61-2.42h.17v1.53c0,4-2.17,6.24-5.67,6.24a5.88,5.88,0,0,1-5.36-3.78l-4.06,1.7a10.13,10.13,0,0,0,9.41,6.28c5.48,0,10.11-3.22,10.11-11.09V55h-4.41v1.75Zm-5.37,14.7A6.1,6.1,0,0,1,187.64,65c0-3.75,2.69-6.47,5.91-6.47s5.67,2.75,5.67,6.47S196.75,71.45,193.55,71.45Zm60.95-27.7H243.34V75H248V63.17h6.51c5.17,0,10.25-3.75,10.25-9.7S259.69,43.75,254.5,43.75Zm.14,15H248V48.08h6.64a5.36,5.36,0,1,1,0,10.72Zm28.83-4.47c-3.39,0-6.89,1.51-8.33,4.78l4.14,1.72a4.44,4.44,0,0,1,4.25-2.31c2.42,0,4.86,1.45,4.92,4v.33a10.53,10.53,0,0,0-4.87-1.2c-4.47,0-9,2.45-9,7,0,4.2,3.67,6.89,7.75,6.89a6.57,6.57,0,0,0,5.94-3.06h.17V75h4.5V63C292.94,57.42,288.8,54.33,283.47,54.33Zm-.58,17.12c-1.53,0-3.67-.75-3.67-2.67,0-2.42,2.67-3.34,4.94-3.34a8.16,8.16,0,0,1,4.26,1.06A5.64,5.64,0,0,1,282.89,71.45ZM309.36,55,304,68.55h-.17L298.28,55h-5l8.34,19-4.75,10.53h4.86L314.53,55Zm-42,20H272V43.75h-4.67Z"
        fill="#fff"
      />
      <path
        d="M26.08,18.83a5.08,5.08,0,0,0-1.14,3.53V77.64a4.82,4.82,0,0,0,1.17,3.5l.19.17,31-31v-.7l-31-31Z"
        fill="url(#linear-gradient)"
      />
      <path
        d="M67.58,60.69,57.25,50.36v-.72L67.58,39.31l.23.14L80,46.39c3.5,2,3.5,5.22,0,7.22L67.81,60.55Z"
        fill="url(#linear-gradient-2)"
      />
      <path
        d="M67.81,60.55,57.25,50,26.08,81.17c1.15,1.22,3.06,1.35,5.2.16L67.81,60.55"
        fill="url(#linear-gradient-3)"
      />
      <path
        d="M67.81,39.45,31.28,18.7c-2.14-1.22-4.06-1.06-5.2.17L57.25,50Z"
        fill="url(#linear-gradient-4)"
      />
      <path
        d="M67.58,60.33,31.3,80.94c-2,1.17-3.83,1.09-5,0l-.19.19.19.17c1.17,1,3,1.14,5,0L67.83,60.55Z"
        opacity="0.2"
        style="isolation: isolate"
      />
      <path
        d="M80,53.25,67.55,60.33l.22.22L80,53.61c1.76-1,2.62-2.31,2.62-3.61C82.5,51.2,81.61,52.33,80,53.25Z"
        opacity="0.12"
        style="isolation: isolate"
      />
      <path
        d="M31.28,19.06,80,46.75A4.6,4.6,0,0,1,82.64,50c0-1.3-.86-2.61-2.62-3.61L31.28,18.7c-3.5-2-6.34-.33-6.34,3.66v.36C24.94,18.72,27.78,17.08,31.28,19.06Z"
        fill="#fff"
        opacity="0.25"
        style="isolation: isolate"
      />
    </symbol>
  </svg>

  <main>
    <!-- START WALDO -->
    <div id="waldo" class="projectWrapper projectWrapper--dark" data-lazyvideo>
      <div class="project">
        <div class="projectDetails">
          <div class="projectDetails__Overview">
            <h2 class="projectTitle">There's Waldo (AR)</h2>
            <div class="projectMeta">
              <p><strong>Tools: </strong>Swift, iOS SDK, ARKit, SceneKit</p>
            </div>
            <div class="iconsWrapper">
              <svg class="icon">
                <use xlink:href="#appleIcon"></use>
              </svg>
            </div>
          </div>
          <div class="videoSmallScreen">
            <div class="videoFrame">
              <video loading="lazy" autoplay loop muted playsinline poster="@/assets/images/LoadingPhone.jpg">
                <source src="@/assets/videos/theresWaldo.webm" type="video/webm" />
                <source src="@/assets/videos/theresWaldo.webm" type="video/mp4" />
              </video>
            </div>
          </div>
          <!--projectDetailsOverview-->
          <div class="projectDescription">
            <p>
              Augmented reality application for the popular
              <a href="https://en.wikipedia.org/wiki/Where%27s_Wally%3F" target="_blank" rel="noreferrer"
                >Where's Waldo (Wally)</a
              >
              books.<br /><br />Using Apple's ARKit and camera data, There's Waldo locates that elusive Waldo
              character we all love, as well as his friends and additional missing items. Once found, a 3D
              marker is added into the virtual 'scene' to show the user his whereabouts. Image tracking is
              utilized to continually update the 3D marker(s) should the book or pages be moved.
            </p>
          </div>
          <div class="projectFeatures">
            <p class="projectFeaturesTitle">FEATURES:</p>
            <ul>
              <li>Augmented Reality via Apple's ARKit</li>
              <li>Image identification</li>
              <li>Live image tracking</li>
              <li>
                Custom animated 3D pointer designed with
                <a href="https://www.blender.org/" target="_blank" rel="noreferrer">Blender</a>
              </li>
            </ul>
          </div>
        </div>
        <!--projectDetails-->
        <div class="projectVideo">
          <div class="videoFrame">
            <video
              id="waldoVideo"
              loading="lazy"
              autoplay
              loop
              muted
              playsinline
              poster="@/assets/images/LoadingPhone.jpg"
            >
              <source src="@/assets/videos/theresWaldo.webm" type="video/webm" />
              <source src="@/assets/videos/theresWaldo.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
    <!-- END WALDO -->

    <!-- CALMER CANINE -->
    <div id="calmerCanine" class="projectWrapper projectWrapper--light" data-lazyvideo>
      <div class="project">
        <div class="projectVideo">
          <div class="videoFrame">
            <video
              id="calmerCanineVideo"
              loading="lazy"
              autoplay
              loop
              muted
              playsinline
              poster="@/assets/images/LoadingPhone.jpg"
            >
              <source src="@/assets/videos/calmerCanineMockup.webm" type="video/webm" />
              <source src="@/assets/videos/calmerCanineMockup.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="projectDetails">
          <div class="projectDetails__Overview">
            <h2 class="projectTitle">Calmer Canine</h2>
            <div class="projectMeta">
              <p>
                <strong>Tools: </strong>Android SDK (Kotlin, SQLite), Web (React, Javascript), Backend (PHP,
                MySQL, Javascript)
              </p>
            </div>
            <div class="iconsWrapper">
              <svg class="icon">
                <use xlink:href="#androidIcon"></use>
              </svg>
              <svg class="icon">
                <use xlink:href="#websiteIcon"></use>
              </svg>
            </div>
          </div>
          <div class="videoSmallScreen">
            <div class="videoFrame">
              <video loading="lazy" autoplay loop muted playsinline poster="@/assets/images/LoadingPhone.jpg">
                <source src="@/assets/videos/calmerCanineMockup.webm" type="video/webm" />
                <source src="@/assets/videos/calmerCanineMockup.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
          <!--projectDetailsOverview-->
          <div class="projectDescription">
            <p>
              Application for assisting dog owners whose pets may be suffering from separation anxiety.
              Complete fullstack application for both the web and Android devices. Application backend stores
              quiz submission data and organizes key data points in admin dashboard for analysis. Generated
              report is emailed to the user in PDF format and is available for immediate review upon
              completion. Generated reports take affiliate accounts into consideration and will generate links
              to content along with affiliate data for compensation.<br /><br />
              Android application saves submissions locally for offline use and uploads data when network
              connection is available. Admin section allows for review and management of submissions locally
              on the device.
            </p>
          </div>
          <div class="projectFeatures">
            <p class="projectFeaturesTitle">FEATURES:</p>
            <ul>
              <li>Used by over <strong>15,600 users</strong> (June 17, 2020)</li>
              <li>Backend database design</li>
              <li>Automated email handling</li>
              <li>Automated PDF report generation</li>
              <li>Affiliate program integration</li>
              <li>Administration dashboard</li>
              <li>Fully responsive</li>
            </ul>
          </div>
          <div class="projectLink">
            <a
              class="btn btn--dark"
              href="https://www.calmerk9.com/quiz/app-fe/"
              target="_blank"
              rel="noreferrer"
              >Visit App</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- END CALMER CANINE -->

    <!-- PANDEMIC -->
    <div id="pandemic" class="projectWrapper projectWrapper--dark" data-lazyvideo>
      <div class="project">
        <div class="projectDetails">
          <div class="projectDetails__Overview">
            <h2 class="projectTitle">Pandemic Rapid Response</h2>
            <div class="projectMeta">
              <p><strong>Tools: </strong>Flutter, Dart, Flare</p>
            </div>
            <div class="iconsWrapper">
              <svg class="icon">
                <use xlink:href="#appleIcon"></use>
              </svg>
              <svg class="icon">
                <use xlink:href="#androidIcon"></use>
              </svg>
            </div>
          </div>
          <div class="videoSmallScreen">
            <div class="videoFrame">
              <video loading="lazy" autoplay loop muted playsinline poster="@/assets/images/LoadingPhone.jpg">
                <source src="@/assets/videos/pandemicMockup.webm" type="video/webm" />
                <source src="@/assets/videos/pandemicMockup.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
          <!--projectDetailsOverview-->
          <div class="projectDescription">
            <p>
              Companion app for Z-MAN Games'
              <a
                href="https://www.zmangames.com/en/products/pandemic-rapid-response/"
                target="_blank"
                rel="noreferrer"
                >Pandemic Rapid Response</a
              >
              board game. Manages the timer, timer tokens, city cards in play, and city cards in deck. While
              also supplying an ambient soundtrack, audible alerts are provided as each timer runs out so that
              players can focus on the real-time gameplay without having to continuosly keep watch of the
              silent sand timer provided in the game box.<br /><br />
              UI buttons are drawn in code using Flutter's Custom Painter class so that all elements look
              sharp at any resolution. Vector based animations were created with
              <a href="https://rive.app/" target="_blank" rel="noreferrer">Rive</a> (formerly Flare).
            </p>
          </div>
          <div class="projectFeatures">
            <p class="projectFeaturesTitle">FEATURES:</p>
            <ul>
              <li>Localization (English and French)</li>
              <li>Layouts for portrait and landscape modes</li>
              <li>Automated unit testing</li>
              <li>Shared Preferences for data persistence</li>
              <li>Vector animations</li>
              <li>Custom Painter classes for ui elements</li>
            </ul>
          </div>
          <div class="projectLink">
            <div class="appBadges">
              <a href="https://apps.apple.com/us/app/id1532962242" target="_blank" rel="noreferrer">
                <svg class="badge">
                  <use xlink:href="#appStoreBadge"></use>
                </svg>
              </a>
              <!-- <a href="https://apps.apple.com/us/app/id1532962242" target="_blank" rel="noreferrer">
                  <svg class="badge">
                    <use xlink:href="#googlePlayBadge"></use>
                  </svg>
                </a> -->
            </div>
          </div>
        </div>
        <!--projectDetails-->
        <div class="projectVideo">
          <div class="videoFrame">
            <video
              id="pandemicVideo"
              loading="lazy"
              autoplay
              loop
              muted
              playsinline
              poster="@/assets/images/LoadingPhone.jpg"
            >
              <source src="@/assets/videos/pandemicMockup.webm" type="video/webm" />
              <source src="@/assets/videos/pandemicMockup.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
    <!-- END PANDEMIC -->

    <!-- MEDIATION -->
    <div id="meditation" class="projectWrapper projectWrapper--light" data-lazyvideo>
      <div class="project">
        <div class="projectVideo">
          <div class="videoFrame">
            <video
              id="meditationVideo"
              loading="lazy"
              autoplay
              loop
              muted
              playsinline
              poster="@/assets/images/LoadingPhone.jpg"
            >
              <source src="@/assets/videos/meditationMockup.webm" type="video/webm" />
              <source src="@/assets/videos/meditationMockup.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="projectDetails">
          <div class="projectDetails__Overview">
            <h2 class="projectTitle">Meditation Timer UI</h2>
            <div class="projectMeta">
              <p><strong>Tools: </strong>Swift, iOS SDK</p>
            </div>
            <div class="iconsWrapper">
              <svg class="icon">
                <use xlink:href="#appleIcon"></use>
              </svg>
            </div>
          </div>
          <div class="videoSmallScreen">
            <div class="videoFrame">
              <video loading="lazy" autoplay loop muted playsinline poster="@/assets/images/LoadingPhone.jpg">
                <source src="@/assets/videos/meditationMockup.webm" type="video/webm" />
                <source src="@/assets/videos/meditationMockup.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
          <!--projectDetailsOverview-->
          <div class="projectDescription">
            <p>
              Clone based on the
              <a href="http://www.ensomeditationtimer.com/" target="_blank" rel="noreferrer"
                >Ens&#333; Meditation App.</a
              ><br /><br />
              Coded from scratch in Swift, and making use of Apple's Core Graphics (Quartz2D) framework. UI
              adapts to any screen size, and looks sharp at any device resolution.<br /><br />
              Custom Gesture Recognizer logic converts x,y coordinates into rotational value, while also
              creating stop points at min and max values.
            </p>
          </div>
          <div class="projectFeatures" style="margin-bottom: 0">
            <p class="projectFeaturesTitle">FEATURES:</p>
            <ul>
              <li>Sharp, code-based vector graphics</li>
              <li>Custom gesture recognizer</li>
              <li>Data binding and state management</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- END MEDITATION -->

    <!-- KWJS -->
    <div id="kwjs" class="projectWrapper projectWrapper--dark" data-lazyvideo>
      <div class="project">
        <div class="projectDetails">
          <div class="projectDetails__Overview">
            <h2 class="projectTitle">KWJS Flutter Demo</h2>
            <div class="projectMeta">
              <p><strong>Tools: </strong>Flutter, Dart</p>
            </div>
            <div class="iconsWrapper">
              <svg class="icon">
                <use xlink:href="#appleIcon"></use>
              </svg>
              <svg class="icon">
                <use xlink:href="#androidIcon"></use>
              </svg>
            </div>
          </div>
          <div class="videoSmallScreen">
            <div class="videoFrame">
              <video loading="lazy" autoplay loop muted playsinline poster="@/assets/images/LoadingPhone.jpg">
                <source src="@/assets/videos/kwjsMockup.webm" data-src="kwjsMockup.webm" type="video/webm" />
                <source src="@/assets/videos/kwjsMockup.mp4" data-src="kwjsMockup.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
          <!--projectDetailsOverview-->
          <div class="projectDescription">
            <p>
              Demonstrative app created for the benefit of the
              <a href="https://www.meetup.com/KWJavaScript/" target="_blank" rel="noreferrer"
                >KWJS Meetup Group</a
              >
              in order to highlight the differeneces between the React Native framework and Flutter.
            </p>
          </div>
          <div class="projectFeatures">
            <p class="projectFeaturesTitle">FEATURES:</p>
            <ul>
              <li>Automated unit testing</li>
              <li>Integrates with API for retrieving current events</li>
              <li>Dynamically creates scrolling list</li>
              <li>Dynamic screens with event details</li>
              <li>Navigation</li>
            </ul>
          </div>
          <div class="projectLink">
            <a
              class="btn btn--light"
              href="https://github.com/chuckntaylor/kwjs_flutter_demo"
              target="_blank"
              rel="noreferrer"
              ><div class="iconBtn">
                <svg class="iconBtn__icon">
                  <use xlink:href="#githubIcon"></use></svg
                >View on GitHub
              </div></a
            >
          </div>
        </div>
        <div class="projectVideo">
          <div class="videoFrame">
            <video
              id="kwjsVideo"
              loading="lazy"
              autoplay
              loop
              muted
              playsinline
              poster="@/assets/images/LoadingPhone.jpg"
            >
              <source src="@/assets/videos/kwjsMockup.webm" type="video/webm" />
              <source src="@/assets/videos/kwjsMockup.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
    <!-- END KWJS -->
  </main>

  <footer>
    <p class="copyright">
      Copyright &copy; 2017 - {{ currentYear }}, Chuck Taylor | App Developer, All rights reserved.<br />
      Contact me at:
      <a href="mailto:chuck@chucktaylor.dev?subject=Hey%20Chuck" target="_blank" rel="noopener"
        >chuck@chucktaylor.dev</a
      >
    </p>
  </footer>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'

export default defineComponent({
  setup() {
    gsap.registerPlugin(ScrollTrigger, MotionPathPlugin)

    const startHeaderAnimation = () => {
      /** HEADER ANIMATION **/
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '#logoLarge',
          start: 'bottom top',
          toggleActions: 'play play reverse reverse',
        },
      })

      tl.addLabel('start')
      tl.set('#mainNav', { autoAlpha: 1 })
      tl.to('#mainNav', { duration: 0.3, y: 0, ease: 'power1.out' }, 'start')
    }

    onMounted(() => {
      startHeaderAnimation()
    })

    const currentYear = new Date().getFullYear()
    return {
      currentYear,
    }
  },
})
</script>
